/**
 * The largest e-mail body the API accepts, measured over the normalized markup.
 *
 * Formatting inflates a body well beyond its visible length, so a message an author could send as
 * plain text can exceed this once it is formatted. Validating in the form turns that into a field
 * error instead of an opaque API failure. `RichText`'s own `maxLength` prop only colours the
 * character counter and blocks nothing.
 */
export const EMAIL_BODY_MAX_LENGTH = 65535;
